/**
 * defa.routers.CustomerRouter
 * The Router for the CustomerController, all front end urls starting with /billing/.
 * @version 1.2.0
 */

const CustomerRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		
		'billing/accounts/:userId(/)': 'showCustomerList',
		'billing/create/:userId(/)'  : 'showCustomerCreate',
		'billing/:id(/)'             : 'showCustomerUpdate',
		'billing/:id/invoices(/)'    : 'showCustomerInvoices',
		'invoices/:id(/)'            : 'showInvoice',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default CustomerRouter;
	